import React from "react";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import axios from "axios";
import { green, orange } from "@material-ui/core/colors";
import styles from "./Modal.module.css";
import InheritanceService from "../../services/inheritanceService";

const ModalAutoInherit = ({
    active,
    setActive,
    toggleModal,
    rates,
    hotelId,
    needSavedBanned,
    fromUploadPrices,
    setFromUploadPrices,
}) => {
    async function mobileSync() {
        // await axios.get(`/manager/data/hotels/${hotelId}/mobile_sync`);
    }
    async function submitHandler(e) {
        e.preventDefault();
        // axios.get("/manager/data/vector_turn_off");
        const data = [];
        let el = {};

        for (let [k, v] of Object.entries(e.target)) {
            if (v.id === "stop") break;

            if (k % 2 == 0) {
                el = {};
                el.id = v.id;
            } else {
                if (v.checked) data.push(el);
            }
        }

        if (data.length === 0) {
            alert("Вы не выбрали ни одного тарифа");
            return;
        }

        const waitCursorStyle = document.createElement("style");
        waitCursorStyle.innerText =
            "*, *:before, *:after { cursor: wait !important; pointer-events: none; }";
        document.head.appendChild(waitCursorStyle);

        try {
            // if (needSavedBanned) {
            //     await axios
            //         .get(`/manager/data/hotels/${hotelId}/saved_banned`)
            //         .then((response) => {
            //             console.log("Стопы успешно сохранились");
            //         })
            //         .catch((err) => {
            //             console.error(err);
            //         });
            // }

            for (const d of data) {
                const elname = document.getElementById("rate_inherited" + d.id);
                elname.textContent = "Наследуется...";
                elname.style.color = "blue";
                await axios
                    .post("/manager/data/hotels/" + hotelId + "/auto_inherit", {
                        id: d.id,
                    })
                    .then((response) => {
                        if (response.data.success) {
                            elname.textContent = "Тариф успешно наследован";
                            elname.style.color = "green";
                            // mobileSync();
                        } else {
                            elname.textContent = response.data.message;
                            elname.style.color = "red";
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }

            await InheritanceService.handleInheritance(hotelId, false);

            // await axios
            // .get(`/manager/data/hotels/${hotelId}/restore_banned`)
            // .then((response) => {
            //     console.log("Стопы успешно восстановлены");
            //     axios.get("/manager/data/start_grouping_prices");
            //     mobileSync();
            // })
            // .catch((err) => {
            //     console.error(err);
            // });
        } catch (error) {
            console.error(error);
        } finally {
            waitCursorStyle.remove();
        }
    }

    const cancellHandler = () => {
        setActive(false);
        // mobileSync();
        if (fromUploadPrices) {
            // axios.get("/manager/data/vector_turn_off");
            setFromUploadPrices(false);
        }
    };

    const divStyle = {
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
    };

    const formStyle = {
        display: "flex",
        flexDirection: "column",
        padding: "10px",
    };

    return (
        <div>
            <Dialog
                open={active}
                onClose={toggleModal}
                aria-labelledby="draggable-dialog-title"
                maxWidth="xl"
            >
                <DialogTitle style={{ cursor: "move" }}>
                    Цены следующих наследованных тарифов будут перенаследованы
                </DialogTitle>
                <form style={formStyle} onSubmit={submitHandler}>
                    {rates.map((i, idx) => (
                        <div style={divStyle} key={i.id}>
                            <label htmlFor={"rePrice" + i.id}>
                                <h2>{i.id}</h2>
                            </label>
                            <label htmlFor={"rePrice" + i.id}>
                                <h3 id={"rate_inherited" + i.id}>{i.name}</h3>
                            </label>
                            <input type="hidden" id={i.id} />
                            <input
                                name="rePrice"
                                id={"rePrice" + i.id}
                                type="checkbox"
                                defaultChecked="checked"
                            />
                        </div>
                    ))}
                    <input type="hidden" id="stop" />
                    <button
                        type="button"
                        onClick={() => {
                            const checkboxes = document.querySelectorAll(
                                "input[name='rePrice']",
                            );
                            const allChecked = Array.from(checkboxes).every(
                                (checkbox) => checkbox.checked,
                            );
                            checkboxes.forEach((checkbox) => {
                                checkbox.checked = !allChecked;
                            });
                        }}
                        className={styles.modal__checkout__on__off}
                    >
                        Включить/выключить все
                    </button>
                    <Button
                        variant="contained"
                        endIcon={<ArrowBackIcon />}
                        style={{
                            backgroundColor: orange[500],
                            margin: "30px 5vw 10px",
                        }}
                        onClick={cancellHandler}
                        className={styles.button_cancel}
                    >
                        Выйти
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        endIcon={<SaveIcon />}
                        style={{
                            backgroundColor: green[500],
                            margin: "30px 5vw 10px",
                        }}
                        className={styles.button_confirm}
                        type="submit"
                    >
                        Перенаследовать
                    </Button>
                </form>
            </Dialog>
        </div>
    );
};

export default ModalAutoInherit;
